<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
  </div>
</template>
<script>
import products from "@/api/products.js";
export default {
  created: function() {
    products.loadHistory(result => {
      let entryList = {};
      result.forEach(function(element) {
        if (!entryList["y" + element.west_cal]) {
          entryList["y" + element.west_cal] = {
            west_cal: element.west_cal,
            jp_cal: element.jp_cal,
            entries: []
          };
        }
        entryList["y" + element.west_cal].entries.push(element);
      });
      this.$store.dispatch("setEntryList", entryList);

      this.$nextTick(() => {
        $(window).resize();
      });
      
    });
  },
  watch: {
    '$route': function (to, from) {
      if (window.ga && to.path !== from.path) {
        window.ga('set', 'page', to.path);
        window.ga('send', 'pageview');
      }
    }
  }
};
</script>
<style scoped>

.fade-enter-active {
  transition: opacity 0.2s;
}
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/App.vue